export const BOOKING_URL = 'https://bloomebeautyclub.com/randevu.php';
export const SITE_URL = 'https://bloomebeautyclub.com/';

export const branch = {
  id: 1,
  name: 'Bloome Beauty Batıkent',
  shortName: 'Batıkent',
  type: 'beauty',
  address: 'Velux AVM Batıkent, İnönü, 1729. Sk. No:4/9 C2 Blok D:22, 06200 Yenimahalle/Ankara',
  phone: '0536 908 16 36',
  phonePlain: '+905369081636',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Velux+AVM+Bat%C4%B1kent+%C4%B0n%C3%B6n%C3%BC+1729.+Sk+No4%2F9+C2+Blok+D22+Yenimahalle+Ankara',
  image: 'https://images.unsplash.com/photo-1470259078422-826894b933aa?w=600&q=80',
};

export const hoursSummary = 'Pzt — Cmt · 10:00–20:00 · Paz kapalı';

export const workingHours = [
  { day: 'Pazartesi', hours: '10:00–20:00' },
  { day: 'Salı', hours: '10:00–20:00' },
  { day: 'Çarşamba', hours: '10:00–20:00' },
  { day: 'Perşembe', hours: '10:00–20:00' },
  { day: 'Cuma', hours: '10:00–20:00' },
  { day: 'Cumartesi', hours: '10:00–20:00' },
  { day: 'Pazar', hours: 'Kapalı' },
] as const;

export const beautyServices = [
  { id: 1, name: 'Protez Tırnak',      category: 'Tırnak',    icon: '💅', desc: 'Doğal görünümlü, uzun ömürlü protez tırnak uygulamaları.', image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600&q=80' },
  { id: 2, name: 'Nail Art',           category: 'Tırnak',    icon: '🎨', desc: 'Özgün tasarımlar ve yaratıcı tırnak sanatı.',              image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600&q=80' },
  { id: 3, name: 'Kalıcı Oje',         category: 'Tırnak',    icon: '✨', desc: '3–4 hafta kalıcılık garantili jel oje uygulaması.',       image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600&q=80' },
  { id: 4, name: 'Manikür & Pedikür',  category: 'Bakım',     icon: '🌸', desc: 'El ve ayak bakımında profesyonel dokunuş.',               image: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=600&q=80' },
  { id: 5, name: 'Kirpik Lifting',     category: 'Göz & Kaş', icon: '👁️', desc: 'Kirpiklerinizi doğal yollarla kıvırcıklaştırır ve uzatır.', image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&q=80' },
  { id: 6, name: 'İpek Kirpik',        category: 'Göz & Kaş', icon: '🌟', desc: 'Hacimli ve doğal görünümlü ipek kirpik uygulaması.',      image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&q=80' },
  { id: 7, name: 'Kaş Laminasyonu',   category: 'Göz & Kaş', icon: '🦋', desc: 'Kaşlarınıza şekil ve hacim kazandıran laminasyon.',       image: 'https://images.unsplash.com/photo-1524638431109-93d95c968f03?w=600&q=80' },
];
